// extracted by mini-css-extract-plugin
export default {"container":"DesignerItem-module__container___1irie","image":"DesignerItem-module__image___tudyL"};